import React, { Suspense, lazy, useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Favicon from 'react-favicon';
import { connect } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';

import DashboardLayout from 'layout/DashboardLayout';

import Loading from 'components/Loading';
import Head from 'components/Head';

import { convertGSToDownloadURL } from 'utils';
import buildMatch from 'utils/buildMatch';

const Upgrade = lazy(() => import('modules/Users/container/Upgrade'));

const UpgradePage = ({ teams, user, matchpath }) => {
  const location = useLocation();
  const params = useParams();
  const match = buildMatch(location, params, matchpath);

  const [favicon, setFavicon] = useState('');

  const getOwnedTeam = useCallback(() => {
    if (teams && teams.length) {
      return teams?.find((t) => t.owner === user.uid) || teams[0];
    }

    return null;
  }, [teams, user]);

  useEffect(() => {
    const team = getOwnedTeam();

    if (team) {
      const { isDisabled, customBranding, theme } = team;

      if (isDisabled === false && customBranding && theme.iconURL) {
        if (theme.iconURL.startsWith('gs://')) {
          setFavicon(convertGSToDownloadURL(theme.iconURL, false));
        }
      } else {
        setFavicon('/favicon.ico');
      }
    } else {
      setFavicon('/favicon.ico');
    }
  }, [getOwnedTeam]);

  return (
    <>
      <Favicon url={favicon} />
      <Head
        title={`${
          match.path === '/upgrade/confirm/:plan'
            ? 'Payment summary'
            : 'Upgrade'
        }`}
      />
      <DashboardLayout match={match}>
        <Suspense fallback={<Loading />}>
          <Upgrade match={match} location={location} />
        </Suspense>
      </DashboardLayout>
    </>
  );
};

const mapStateToProps = ({ user: { user }, team: { teams } }) => ({
  user,
  teams,
});

UpgradePage.propTypes = {
  user: PropTypes.object.isRequired,
  teams: PropTypes.array,
  matchpath: PropTypes.string,
};

export default connect(mapStateToProps)(UpgradePage);
